'use client';

import React, { useState } from 'react';
import Link from 'next/link';

// ─── KHALIFAH SL TERM BLOCK ───────────────────────────────────────────────────
export function KhalifahSLTerm() {
  const [expanded, setExpanded] = useState(false);
  return (
    <div style={{
      background: 'rgba(201,168,76,0.05)',
      border: '1px solid rgba(201,168,76,0.25)',
      borderRadius: 8,
      overflow: 'hidden',
      margin: '24px 0',
    }}>
      {/* Header — always visible */}
      <button
        onClick={() => setExpanded(v => !v)}
        style={{
          width: '100%',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '18px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          textAlign: 'left',
        }}
      >
        {/* SL badge */}
        <div style={{
          background: 'rgba(201,168,76,0.12)',
          border: '1px solid rgba(201,168,76,0.3)',
          borderRadius: 4,
          padding: '4px 8px',
          fontSize: 8,
          color: '#c9a84c',
          letterSpacing: '.15em',
          textTransform: 'uppercase',
          flexShrink: 0,
        }}>
          SL GLOSSARY
        </div>

        {/* Arabic + transliteration */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            fontFamily: "'Amiri', serif",
            fontSize: 26,
            color: '#c9a84c',
            lineHeight: 1.1,
            direction: 'rtl',
          }}>
            خَلِيفَة
          </div>
          <div style={{ fontSize: 12, color: '#d4c5a9', fontStyle: 'italic', marginTop: 2 }}>
            Khalifah — Caretaker
          </div>
        </div>

        {/* Root */}
        <div style={{ textAlign: 'right', flexShrink: 0 }}>
          <div style={{ fontSize: 14, color: 'rgba(201,168,76,0.5)', fontFamily: "'Amiri', serif", letterSpacing: 4 }}>
            خ - ل - ف
          </div>
          <div style={{ fontSize: 9, color: '#7a6f5d', marginTop: 2 }}>Kha · Lam · Fa</div>
        </div>

        {/* Toggle */}
        <div style={{
          color: '#c9a84c',
          fontSize: 16,
          flexShrink: 0,
          transform: expanded ? 'rotate(45deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s',
        }}>+</div>
      </button>

      {/* Expanded content */}
      {expanded && (
        <div style={{
          padding: '0 20px 20px',
          borderTop: '1px solid rgba(201,168,76,0.12)',
          animation: 'khalifahExpand 0.2s ease',
        }}>
          <style>{`@keyframes khalifahExpand { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }`}</style>

          {/* Root meanings */}
          <div style={{ marginTop: 16, marginBottom: 16 }}>
            <div style={{ fontSize: 8, color: '#c9a84c', letterSpacing: '.15em', textTransform: 'uppercase', marginBottom: 10 }}>
              ROOT MEANINGS — خ - ل - ف
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {['To come after, to succeed', 'To be a successor, a deputy', 'To be entrusted with stewardship', 'To follow in the footsteps of', 'To be appointed as a caretaker'].map((m, i) => (
                <span key={i} style={{
                  fontSize: 11,
                  color: '#9a8f7d',
                  background: 'rgba(201,168,76,0.05)',
                  border: '1px solid rgba(201,168,76,0.1)',
                  borderRadius: 3,
                  padding: '3px 8px',
                }}>
                  {m}
                </span>
              ))}
            </div>
          </div>

          {/* Definition */}
          <p style={{ fontSize: 13, color: '#d4c5a9', lineHeight: 1.75, fontFamily: "'Georgia', serif", marginBottom: 16 }}>
            You are a successor. You come after those who came before. You inherit the trust. You are a Khalifah — a caretaker. The role was named before the arrival: not observer, not student, not seeker — Khalifah. The identity precedes the level.
          </p>

          {/* Quran 2:30 anchor */}
          <div style={{
            background: 'rgba(6,13,18,0.5)',
            border: '1px solid rgba(201,168,76,0.15)',
            borderLeft: '3px solid rgba(201,168,76,0.5)',
            borderRadius: '0 6px 6px 0',
            padding: '14px 16px',
            marginBottom: 16,
          }}>
            <div style={{ fontSize: 8, color: '#c9a84c', letterSpacing: '.15em', textTransform: 'uppercase', marginBottom: 8 }}>
              QURAN 2:30 — THE APPOINTMENT
            </div>
            <p style={{
              fontFamily: "'Georgia', serif",
              fontStyle: 'italic',
              fontSize: 13,
              color: '#d4c5a9',
              lineHeight: 1.8,
              marginBottom: 6,
            }}>
              "And when your Lord said to the angels: 'I am placing in the earth a Khalifah.'"
            </p>
            <div style={{ fontSize: 9, color: '#c9a84c' }}>Quran 2:30</div>
          </div>

          {/* Founder's note */}
          <div style={{
            background: 'rgba(6,13,18,0.4)',
            border: '1px solid rgba(201,168,76,0.1)',
            borderRadius: 6,
            padding: '12px 16px',
            marginBottom: 16,
          }}>
            <div style={{ fontSize: 8, color: '#7a6f5d', letterSpacing: '.15em', textTransform: 'uppercase', marginBottom: 6 }}>
              ◈ FROM THE LETTER
            </div>
            <p style={{ fontSize: 12, color: '#9a8f7d', lineHeight: 1.65, fontStyle: 'italic' }}>
              "'Khalifah', loosely translated as 'caretaker', is what we were sent to the earth as. A test to see which of us is excellent in work with the trust that we are granted care over."
            </p>
          </div>

          {/* SL Glossary link */}
          <Link
            href="/sl-glossary"
            style={{
              display: 'inline-block',
              fontSize: 10,
              color: '#c9a84c',
              textDecoration: 'none',
              border: '1px solid rgba(201,168,76,0.25)',
              borderRadius: 4,
              padding: '6px 12px',
            }}
          >
            → View in SL Glossary
          </Link>
        </div>
      )}
    </div>
  );
}

// ─── FOUNDER'S THREAD VOICE ───────────────────────────────────────────────────
export function FounderThreadVoice({
  passage,
  context,
}: {
  passage: string;
  context: string;
}) {
  return (
    <div style={{
      background: 'rgba(6,13,18,0.7)',
      border: '1px solid rgba(201,168,76,0.2)',
      borderLeft: '3px solid rgba(201,168,76,0.6)',
      borderRadius: '0 8px 8px 0',
      padding: '18px 20px',
      margin: '20px 0',
      position: 'relative',
    }}>
      {/* Thread marker */}
      <div style={{
        position: 'absolute',
        top: -1,
        left: -1,
        background: 'rgba(201,168,76,0.15)',
        border: '1px solid rgba(201,168,76,0.3)',
        borderRadius: '0 0 4px 0',
        padding: '3px 8px',
        fontSize: 7,
        color: '#c9a84c',
        letterSpacing: '.15em',
        textTransform: 'uppercase',
      }}>
        FOUNDER'S THREAD
      </div>

      <div style={{ marginTop: 16 }}>
        <p style={{
          fontFamily: "'Georgia', serif",
          fontStyle: 'italic',
          fontSize: 13,
          color: '#d4c5a9',
          lineHeight: 1.8,
          marginBottom: 10,
        }}>
          "{passage}"
        </p>
        <div style={{ fontSize: 10, color: '#7a6f5d', fontStyle: 'italic' }}>
          — {context}
        </div>
      </div>
    </div>
  );
}

// ─── THREE TASKS MAPPING CALLOUT ──────────────────────────────────────────────
export function ThreeTasksCallout() {
  const [expanded, setExpanded] = useState(false);

  const tasks = [
    {
      number: '01',
      task: "Don\'t transgress in the Mizan",
      arabic: 'الْمِيزَان',
      platform: 'Muslim Resource Guide',
      platformNote: 'The MRG identifies where the Mizan has been transgressed (ward disparities) and provides means for restoration (Islah).',
      href: '/muslim-resource-guide',
      color: '#2d7a47',
    },
    {
      number: '02',
      task: 'Recognize Ayat in creation',
      arabic: 'آيَاتٌ فِي الْآفَاق',
      platform: 'Ayat in Creation + IRL Lens',
      platformNote: 'The environment design layer and the interpretive tool for reading Names in the manifest world.',
      href: '/ayat-in-creation',
      color: '#2d8a87',
    },
    {
      number: '03',
      task: 'Recognize Ayat in revelation',
      arabic: 'آيَاتٌ فِي الْأَنفُس',
      platform: 'Keys to Kulli Haal',
      platformNote: 'The curriculum drawn from the Quran and Sunnah — the Sacred Language vocabulary, the guidance infrastructure.',
      href: '/keys-to-kulli-haal',
      color: '#c9a84c',
    },
  ];

  return (
    <div style={{
      background: 'rgba(6,13,18,0.5)',
      border: '1px solid rgba(201,168,76,0.2)',
      borderRadius: 8,
      overflow: 'hidden',
      margin: '24px 0',
    }}>
      {/* Header */}
      <button
        onClick={() => setExpanded(v => !v)}
        style={{
          width: '100%',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          textAlign: 'left',
          gap: 12,
        }}
      >
        <div>
          <div style={{ fontSize: 8, color: '#c9a84c', letterSpacing: '.15em', textTransform: 'uppercase', marginBottom: 6 }}>
            THE KHALIFAH'S THREE TASKS
          </div>
          <div style={{ fontSize: 13, color: '#d4c5a9', lineHeight: 1.5 }}>
            "We are tasked with not transgressing in the balance, recognizing the signs in creation alongside the signs in revelation, and following the guidance."
          </div>
        </div>
        <div style={{
          color: '#c9a84c',
          fontSize: 16,
          flexShrink: 0,
          transform: expanded ? 'rotate(45deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s',
        }}>+</div>
      </button>

      {/* Expanded task mapping */}
      {expanded && (
        <div style={{
          padding: '0 20px 20px',
          borderTop: '1px solid rgba(201,168,76,0.1)',
          animation: 'tasksExpand 0.2s ease',
        }}>
          <style>{`@keyframes tasksExpand { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }`}</style>

          <div style={{ marginTop: 16, marginBottom: 12 }}>
            <p style={{ fontSize: 11, color: '#7a6f5d', lineHeight: 1.6, fontStyle: 'italic', marginBottom: 16 }}>
              "Alongside" — not sequentially. The three tasks are concurrent. The IRL Lens, the Keys, and the MRG are all plantable from the start, cultivable in parallel, cross-pollinating through the root system.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {tasks.map((t) => (
              <Link
                key={t.number}
                href={t.href}
                style={{
                  display: 'block',
                  background: `${t.color}0d`,
                  border: `1px solid ${t.color}33`,
                  borderRadius: 6,
                  padding: '14px 16px',
                  textDecoration: 'none',
                  transition: 'background 0.2s',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <div style={{ fontSize: 9, color: t.color, fontFamily: 'monospace', flexShrink: 0, marginTop: 2 }}>
                    {t.number}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
                      <div style={{ fontSize: 12, color: '#d4c5a9' }}>{t.task}</div>
                      <div style={{ fontFamily: "'Amiri', serif", fontSize: 14, color: t.color }}>{t.arabic}</div>
                    </div>
                    <div style={{ fontSize: 10, color: t.color, letterSpacing: '.06em', marginBottom: 4 }}>
                      → {t.platform}
                    </div>
                    <div style={{ fontSize: 10, color: '#7a6f5d', lineHeight: 1.5 }}>
                      {t.platformNote}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div style={{
            marginTop: 14,
            padding: '10px 14px',
            background: 'rgba(201,168,76,0.04)',
            border: '1px solid rgba(201,168,76,0.1)',
            borderRadius: 4,
            fontSize: 10,
            color: '#7a6f5d',
            fontStyle: 'italic',
            lineHeight: 1.6,
          }}>
            Task 3 (Follow the guidance) → The journey itself — the Guided Intro, the Walkthrough, the Bridge pages, the quest lines, the progression from Aware to Conscious to Acting.
          </div>
        </div>
      )}
    </div>
  );
}

// ─── QURAN-FIRST ANNOTATION ───────────────────────────────────────────────────
export function QuranFirstAnnotation() {
  const [expanded, setExpanded] = useState(false);
  return (
    <div style={{
      background: 'rgba(6,13,18,0.6)',
      border: '1px solid rgba(45,138,135,0.25)',
      borderRadius: 8,
      overflow: 'hidden',
      margin: '20px 0',
    }}>
      <button
        onClick={() => setExpanded(v => !v)}
        style={{
          width: '100%',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 14,
          textAlign: 'left',
        }}
      >
        <div style={{
          background: 'rgba(45,138,135,0.12)',
          border: '1px solid rgba(45,138,135,0.3)',
          borderRadius: 4,
          padding: '4px 8px',
          fontSize: 8,
          color: '#2d8a87',
          letterSpacing: '.12em',
          textTransform: 'uppercase',
          flexShrink: 0,
        }}>
          QURAN-FIRST
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 12, color: '#d4c5a9', lineHeight: 1.5 }}>
            "There is no better introduction to the way of life than the Quran itself"
          </div>
          <div style={{ fontSize: 10, color: '#7a6f5d', marginTop: 3 }}>
            The hierarchy: Quran → Open Letter → Platform
          </div>
        </div>
        <div style={{
          color: '#2d8a87',
          fontSize: 16,
          flexShrink: 0,
          transform: expanded ? 'rotate(45deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s',
        }}>+</div>
      </button>

      {expanded && (
        <div style={{
          padding: '0 20px 20px',
          borderTop: '1px solid rgba(45,138,135,0.12)',
          animation: 'quranFirstExpand 0.2s ease',
        }}>
          <style>{`@keyframes quranFirstExpand { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }`}</style>

          <div style={{ marginTop: 16 }}>
            <p style={{ fontSize: 13, color: '#d4c5a9', lineHeight: 1.75, fontFamily: "'Georgia', serif", marginBottom: 16 }}>
              "The superlative of recitation, declaration, expression" — the founder defines the Quran not as a book but as the highest form of three things: recitation (reading aloud), declaration (public statement), and expression (creative articulation).
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
              {[
                { mode: 'Recitation', arabic: 'تِلَاوَة', desc: 'The garden speaks — Quranic audio, the module reads its anchoring verse. The caretaker receives.', yaqeen: 'Ilm Yaqeen', color: '#2d8a87' },
                { mode: 'Declaration', arabic: 'إِعْلَان', desc: 'The caretaker speaks — submits an observation, declares a Haqq statement, publicly commits to an Amanah. The garden witnesses.', yaqeen: 'Ayn Yaqeen', color: '#c9a84c' },
                { mode: 'Expression', arabic: 'تَعْبِير', desc: 'The caretaker creates — composes an observation chain, weaves a garment thread, builds a bridge between two haals. The garden grows.', yaqeen: 'Haqq Yaqeen', color: '#2d7a47' },
              ].map((item) => (
                <div key={item.mode} style={{
                  background: `${item.color}0d`,
                  border: `1px solid ${item.color}22`,
                  borderRadius: 6,
                  padding: '12px 14px',
                  display: 'flex',
                  gap: 12,
                  alignItems: 'flex-start',
                }}>
                  <div style={{ flexShrink: 0 }}>
                    <div style={{ fontFamily: "'Amiri', serif", fontSize: 18, color: item.color }}>{item.arabic}</div>
                    <div style={{ fontSize: 9, color: item.color, letterSpacing: '.08em', textTransform: 'uppercase' }}>{item.mode}</div>
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 10, color: '#9a8f7d', lineHeight: 1.55, marginBottom: 4 }}>{item.desc}</div>
                    <div style={{ fontSize: 9, color: item.color, fontStyle: 'italic' }}>Maps to: {item.yaqeen}</div>
                  </div>
                </div>
              ))}
            </div>

            <div style={{
              padding: '12px 14px',
              background: 'rgba(6,13,18,0.5)',
              border: '1px solid rgba(45,138,135,0.15)',
              borderRadius: 6,
              fontSize: 11,
              color: '#7a6f5d',
              lineHeight: 1.65,
              fontStyle: 'italic',
            }}>
              "The concepts I've mentioned are from English translations of a few ideas within it." — The platform is a translation of the Quran, not the Quran itself. Every module is a response to a verse, not a replacement for one.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
